<template>
    <v-sheet rounded elevation="2" class="my-4 pa-4" v-bind="$attrs">
        <div
            v-if="title"
            class="text-subtitle-1 font-weight-bold mb-1"
            v-text="title"
        />
        <slot></slot>
    </v-sheet>
</template>

<script>
export default {
    name: "FormSection",

    props: ["title"],
};
</script>

<style scoped></style>
